import {
  any, string, date, nullable,
  number, boolean,
} from '@sda/sdk/helpers/types.bitmasks';

export const PrivatePendingProfileMask = {
  createdAt: any,
  pendingShowReviewId: string | nullable,
  profileEmail: string,
  profileEmailExists: boolean,
  updatedAt: any,
  lastOnlineAt: date,
  numShowsFinished: number,
  defaultHyperwalletAccountId: string | nullable,
  profileType: string,
  targetProfileId: string | nullable,
  targetProfileType: string | nullable,
};
